import React from 'react';

const Footer = () => {

    return (
        <footer class="pt-4 pb-1 text-center bg-light">
            <div class="container">
                <div class="my-3">
                    <div class="h4 y3">Sornpat Amthiangtham</div>
                    <p>FullStack Web Developer & BackEnd Developer</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
